// This file can be edited directly in Shopify Assets to update the locator without rebuilding the app.
// Maintain the structure: Array of objects with unique IDs.
// Version: 1.1.4 (add version to force cache refresh)

window.VIOFO_INSTALLERS = [
  // --- UNITED STATES ---
  {
    id: "us-az-01",
    name: "EzDashcam",
    address: "1220 W Alameda Dr, Ste 109",
    city: "Tempe",
    state: "AZ",
    country: "United States",
    postalCode: "85282",
    phone: "+1 (602) 456-0126 / 1-844-DASHCAM (327-4226)",
    email: "",
    website: "ezdashcam.com",
    description: "Arizona's premier dash camera retailer and installation service provider specializing in high-performance vehicle recording systems. Authorized dealer for VIOFO, Vantrue, Thinkware, Garmin, and other leading brands. Offering both in-store installation in Tempe and mobile installation services across Arizona with 5-star rated professional service.",
    services: ["Dashcam Installation", "Mobile Installation", "Multi-Channel Systems", "4K Dash Cameras", "Professional Wiring"],
    hours: "By Appointment",
    coordinates: { lat: 33.4152, lng: -111.9093 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-az-02",
    name: "The Dashcam Guru LLC",
    address: "2733 N Power Rd Ste 102 PMB 415",
    city: "Mesa",
    state: "AZ",
    country: "United States",
    postalCode: "85215",
    phone: "+1 623-565-7328",
    email: "",
    website: "thedashcamguru.com",
    description: "East Valley's trusted dashcam installation and consultation service specializing in personalized vehicle protection solutions. Expert guidance on selecting the right dashcam for your specific needs, professional mobile installation, and comprehensive ongoing support. Serving the East Valley area exclusively by appointment with a mission-driven approach to road safety.",
    services: ["Mobile Installation", "Dashcam Consultation", "Professional Wiring", "Ongoing Support", "Multi-Channel Systems"],
    hours: "By Appointment Only",
    coordinates: { lat: 33.4484, lng: -111.6843 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-co-01",
    name: "HachiElectronics",
    address: "2482 E 110th Pl",
    city: "Northglenn",
    state: "CO",
    country: "United States",
    postalCode: "80233",
    phone: "+1 309-262-6796",
    email: "info@hachielectronics.com",
    website: "hachielectronics.com",
    description: "Specialized automotive electronics shop serving the Denver metro area with expertise in dash camera sales and installation. Authorized dealer for VIOFO, Vantrue, Blackvue, and Thinkware dash cameras with vehicle-specific wiring solutions. Offering professional installation services with personalized customer support and technical consultation. Located in Northglenn with a focus on quality products and expert advice.",
    services: ["Dashcam Installation", "Professional Wiring", "Vehicle Electronics", "Multi-Channel Systems", "Technical Consultation"],
    hours: "Contact for Appointment",
    coordinates: { lat: 39.9139, lng: -104.9806 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-ma-01",
    name: "Pro Car Sound and Security",
    address: "267 Broadway",
    city: "Malden",
    state: "MA",
    country: "United States",
    postalCode: "02148",
    phone: "+1 (781) 605-3526",
    email: "",
    website: "procarsoundsecurity.com",
    description: "Professional automotive electronics and security installation shop serving the greater Boston area. Specializing in car audio systems, security installations, and dash camera solutions. Expert installation services for vehicle security systems including dashcams, alarm systems, and remote starters. Located in Malden with experienced technicians providing quality workmanship and customer service.",
    services: ["Dashcam Installation", "Car Security Systems", "Professional Wiring", "Car Audio Installation", "Remote Starters"],
    hours: "Contact for Hours",
    coordinates: { lat: 42.4251, lng: -71.0662 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-or-01",
    name: "Logicview",
    address: "Mobile Service",
    city: "Portland",
    state: "OR",
    country: "United States",
    postalCode: "97236",
    phone: "+1 503-442-2233",
    email: "",
    website: "facebook.com/p/Logicview-61574982325163",
    description: "Professional mobile dashcam installation service serving the Portland metro area. Specializing in convenient on-site installation at your home or workplace, Logicview provides expert setup of VIOFO and other leading dashcam systems. Dedicated to delivering quality workmanship and customer satisfaction with flexible scheduling to meet your needs.",
    services: ["Mobile Installation", "Dashcam Installation", "Professional Wiring", "Multi-Channel Systems", "On-Site Service"],
    hours: "By Appointment Only",
    coordinates: { lat: 45.4947, lng: -122.5253 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-wa-01",
    name: "Seattle Dash Cams",
    address: "Mobile Service",
    city: "Seattle",
    state: "WA",
    country: "United States",
    postalCode: "98101",
    phone: "+1 206-552-0856",
    email: "",
    website: "seattledashcams.com",
    description: "MECP-certified mobile dash camera installation service serving the Seattle metro area and surrounding communities. Specializing in professional on-location setup at your home, office, or preferred location. Offering single-channel, dual-channel, and three-channel VIOFO dash camera systems with shop-quality installation delivered to your driveway. Expert team committed to quality workmanship and customer satisfaction.",
    services: ["Mobile Installation", "Dashcam Installation", "Professional Wiring", "Multi-Channel Systems", "MECP Certified"],
    hours: "By Appointment Only",
    coordinates: { lat: 47.6062, lng: -122.3321 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-ny-01",
    name: "Prince Custom Auto",
    address: "13409 36th Rd",
    city: "Flushing",
    state: "NY",
    country: "United States",
    postalCode: "11354",
    phone: "+1 718-621-9888",
    email: "",
    website: "yelp.com/biz/prince-custom-auto-flushing",
    description: "Professional auto customization and repair shop in Flushing, Queens. Specializing in dashcam installation with expert knowledge of VIOFO systems. We offer custom car interior work, stereo installation, and comprehensive automotive services.",
    services: ["Dashcam Installation", "Car Stereo Installation", "Custom Interior", "Ceramic Coating", "Car Wrap"],
    hours: "Mon-Sun: 9AM - 7PM",
    coordinates: { lat: 40.7595, lng: -73.8297 },
    imageUrl: "https://s3-media0.fl.yelpcdn.com/bphoto/ZSViFmkqLJL2csZLteycqg/o.jpg"
  },
  {
    id: "us-ny-02",
    name: "Blitz Auto Solutions",
    address: "175 Rte 9W #1",
    city: "Congers",
    state: "NY",
    country: "United States",
    postalCode: "10920",
    phone: "+1 877-552-5489",
    email: "info@blitzautony.com",
    website: "blitzautony.com",
    description: "Premier automotive customization and electrical service provider with over 14 years of experience. Specializing in dashcam installation, remote starters, vehicle upfitting, and high-tech accessories. Serving commercial fleets and personal vehicles.",
    services: ["Dashcam Installation", "Remote Start Systems", "Vehicle Upfitting", "Auto Customization", "Fleet Services"],
    hours: "Mon-Fri: 9AM - 6PM",
    coordinates: { lat: 41.1587, lng: -73.9446 },
    imageUrl: " "
  },
  {
    id: "us-ca-01",
    name: "dashcam4u",
    address: "50 Bluff Cove Dr",
    city: "Aliso Viejo",
    state: "CA",
    country: "United States",
    postalCode: "92656",
    phone: "+1 949-235-0368",
    email: "",
    website: "dashcam4u.com",
    description: "Leading dashcam installation service provider specializing in VIOFO, VUGERA, and AZDOME systems. Offering professional, neat, and friendly installation with special considerations for veterans and seniors. Serving multiple locations across Orange County.",
    services: ["Dashcam Installation", "2-Channel Systems", "3-Channel Systems", "Professional Wiring"],
    hours: "By Appointment",
    coordinates: { lat: 33.5789, lng: -117.7256 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-ca-02",
    name: "LA Dash Cams",
    address: "18247 Parthenia St #11",
    city: "Northridge",
    state: "CA",
    country: "United States",
    postalCode: "91325",
    phone: "+1 818-527-6074",
    email: "sales@ladashcams.com",
    website: "ladashcams.com",
    description: "LA's trusted source for high-quality dash camera solutions. Specializing in professional dashcam installation, backup camera systems, and vehicle customization. Delivering reliable, high-quality service for drivers across Los Angeles with focus on clarity, safety, and performance.",
    services: ["Dashcam Installation", "Backup Camera Installation", "Vehicle Customization", "Auto Electronics"],
    hours: "By Appointment",
    coordinates: { lat: 34.2356, lng: -118.5531 },
    imageUrl: "https://images.pexels.com/photos/4489741/pexels-photo-4489741.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-fl-01",
    name: "Mobile Dynamics LLC",
    address: "3103 81st Ct E, Unit 108",
    city: "Bradenton",
    state: "FL",
    country: "United States",
    postalCode: "34211",
    phone: "+1 603-512-5327",
    email: "",
    website: "mobiledynamicsfl.com",
    description: "Boutique mobile electronics store specializing in professional dashcam installation for cars, trucks, Jeeps, and commercial vehicles. Offering hidden wiring, hardwired power, and clean integration with brands like Momento, Alpine, and DroneMobile. Serving Bradenton, Sarasota, and Tampa Bay area.",
    services: ["Dashcam Installation", "Car Audio Upgrades", "Backup Cameras", "Remote Start Systems", "Window Tinting"],
    hours: "Mon-Fri: 9AM - 6PM, Sat: 9AM - 2PM",
    coordinates: { lat: 27.4764, lng: -82.4612 },
    imageUrl: "https://images.pexels.com/photos/5835359/pexels-photo-5835359.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-pa-01",
    name: "BR Electric & Audio Visual",
    address: "57N 11th Street",
    city: "Indiana",
    state: "PA",
    country: "United States",
    postalCode: "15701",
    phone: "+1 724-388-4285",
    email: "",
    website: "brelectricav.com",
    description: "Professional electrical and audio-visual services provider specializing in dashcam installation, car audio systems, and vehicle electronics. Serving Indiana County and surrounding areas with expert installation and customer service.",
    services: ["Dashcam Installation", "Car Audio Installation", "Vehicle Electronics", "Audio Visual Systems"],
    hours: "Mon-Fri: 9AM - 5PM",
    coordinates: { lat: 40.6215, lng: -79.1525 },
    imageUrl: "https://images.pexels.com/photos/3806288/pexels-photo-3806288.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-tx-01",
    name: "Lee Car Audio",
    address: "8832 Chaps Ave",
    city: "Keller",
    state: "TX",
    country: "United States",
    postalCode: "76244",
    phone: "+1 817-217-4204",
    email: "",
    website: "yelp.com/biz/lees-mobile-car-audio-installations-fort-worth",
    description: "Mobile car audio and electronics installation service serving the Fort Worth and Keller areas. Specializing in convenient on-site installation services including dashcams, car audio systems, and vehicle electronics. Professional mobile installation bringing expert service directly to your location with flexible scheduling.",
    services: ["Mobile Installation", "Dashcam Installation", "Car Audio Installation", "Professional Wiring", "On-Site Service"],
    hours: "By Appointment Only",
    coordinates: { lat: 32.9346, lng: -97.2297 },
    imageUrl: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-tx-02",
    name: "Dash Cam Solutions LLC",
    address: "5877 Babcock Rd",
    city: "San Antonio",
    state: "TX",
    country: "United States",
    postalCode: "78240",
    phone: "+1 210-722-5662",
    email: "",
    website: "dashcamsolutions.com",
    description: "Professional dashcam installation and vehicle camera solutions serving San Antonio and surrounding areas. Specializing in comprehensive dashcam systems, commercial fleet installations, and advanced driver assistance solutions. Expert installation services for all vehicle types with focus on quality workmanship and customer satisfaction.",
    services: ["Dashcam Installation", "Fleet Solutions", "Commercial Installation", "Camera Systems", "Professional Installation"],
    hours: "Mon-Fri: 9AM - 6PM, Sat: 10AM - 4PM",
    coordinates: { lat: 29.5243, lng: -98.5816 },
    imageUrl: "https://images.pexels.com/photos/788855/pexels-photo-788855.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-tx-03",
    name: "HTXdashcams",
    address: "9000 Park West Dr",
    city: "Houston",
    state: "TX",
    country: "United States",
    postalCode: "77063",
    phone: "+1 832-576-5276",
    email: "Danny@htxdashcams.com",
    website: "htxdashcams.com",
    description: "Houston's premier dashcam installation specialist offering professional mobile and in-shop services. Expert hardwired installations with parking mode capability, featuring clean wire concealment and OEM-quality appearance. Fast installation typically completed in under one hour. Specializing in premium VIOFO and Vantrue systems for both personal and commercial vehicles. Comfortable waiting area with refreshments available.",
    services: ["Mobile Installation", "Hardwired Installation", "Dashcam Sales", "Multi-Channel Systems", "Commercial Solutions", "Same-Day Service"],
    hours: "Mon-Sat: 9AM - 6PM",
    coordinates: { lat: 29.7355, lng: -95.5815 },
    imageUrl: "https://images.pexels.com/photos/248687/pexels-photo-248687.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  },
  {
    id: "us-ca-03",
    name: "DashCalm",
    address: "275 S 3rd St",
    city: "Burbank",
    state: "CA",
    country: "United States",
    postalCode: "91502",
    phone: "+1 323-244-7889",
    email: "",
    website: "dashcalm.com",
    description: "Professional dashcam installation and sales serving Burbank and the Greater Los Angeles area. Specializing in high-quality VIOFO dashcam systems with expert installation services. Offering comprehensive vehicle camera solutions including front and rear camera setups, parking mode installations, and professional hardwiring. Dedicated to providing peace of mind through reliable dashcam technology and superior customer service.",
    services: ["Dashcam Installation", "Professional Hardwiring", "Front & Rear Camera Setup", "Parking Mode Installation", "Dashcam Sales", "VIOFO Specialist"],
    hours: "Mon-Fri: 9AM - 6PM, Sat: 10AM - 4PM",
    coordinates: { lat: 34.1808, lng: -118.3090 },
    imageUrl: "https://images.pexels.com/photos/380283/pexels-photo-380283.jpeg?auto=compress&cs=tinysrgb&w=800&h=400&fit=crop"
  }
];